module.exports = __webpack_public_path__ + "static/img/radar.ee852bac.png";